import {isDateDisabled} from '../../DateUtil';
import {
	getTimeRegistrationDateRestrictionInfoMessage,
	isTimeRegistrationDateInvalid,
	isTimeRegistrationDateInvalidWithReason,
	TimeRegistrationDateInvalidInput,
} from './TimeRegistrationDateFilter';
import {createDateFromNullableYMD} from '../../DateUtil';

export function getIsDateDisabledForTaskAndProject({
	date,
	taskStartDate,
	taskEndDate,
	projectStartDate,
	projectEndDate,
	ignoredDates,
}: TimeRegistrationDateInvalidInput): boolean {
	return (
		isDateDisabled(date) ||
		isTimeRegistrationDateInvalid({
			date,
			taskStartDate,
			taskEndDate,
			projectStartDate,
			projectEndDate,
			ignoredDates,
		})
	);
}

export function getIsDateDisabledForTaskAndProjectWithReason({
	date,
	taskStartDate,
	taskEndDate,
	projectStartDate,
	projectEndDate,
	ignoredDates,
}: TimeRegistrationDateInvalidInput): string | null {
	return isDateDisabled(date)
		? 'The company does not allow time registrations on this date'
		: isTimeRegistrationDateInvalidWithReason({
				date,
				taskStartDate,
				taskEndDate,
				projectStartDate,
				projectEndDate,
				ignoredDates,
		  });
}

type TaskWithDates = {
	startYear: number;
	startMonth: number;
	startDay: number;
	deadlineYear: number;
	deadlineMonth: number;
	deadlineDay: number;
};

type TaskDates = {
	taskStartDate: Date | null;
	taskEndDate: Date | null;
};
export function getTaskDates(task: TaskWithDates): TaskDates {
	return {
		taskStartDate: createDateFromNullableYMD({year: task?.startYear, month: task?.startMonth, day: task?.startDay}),
		taskEndDate: createDateFromNullableYMD({
			year: task?.deadlineYear,
			month: task?.deadlineMonth,
			day: task?.deadlineDay,
		}),
	};
}

type ProjectWithDates = {
	projectStartYear: number;
	projectStartMonth: number;
	projectStartDay: number;
	projectEndYear: number;
	projectEndMonth: number;
	projectEndDay: number;
};

type ProjectDates = {
	projectStartDate: Date | null;
	projectEndDate: Date | null;
};
export function getProjectDates(project: ProjectWithDates): ProjectDates {
	return {
		projectStartDate: createDateFromNullableYMD({
			year: project?.projectStartYear,
			month: project?.projectStartMonth,
			day: project?.projectStartDay,
		}),
		projectEndDate: createDateFromNullableYMD({
			year: project?.projectEndYear,
			month: project?.projectEndMonth,
			day: project?.projectEndDay,
		}),
	};
}

export function validateDateReturnErrorMessage(
	selectedDate: {toDate: () => Date},
	task: TaskWithDates,
	project: ProjectWithDates
): string | null {
	return getIsDateDisabledForTaskAndProjectWithReason({
		date: selectedDate.toDate(),
		...getTaskDates(task),
		...getProjectDates(project),
	});
}

export function getDateRestrictionInfo(task: TaskWithDates, project: ProjectWithDates): string | null {
	if (!task || !project) {
		return null;
	}
	return getTimeRegistrationDateRestrictionInfoMessage({
		...getTaskDates(task),
		...getProjectDates(project),
	});
}
